import React from "react";
import { getPizzaSaleModes, getPizzaSaleModePrice } from "../../services/local/pizzaHalfAndHalf";
const originalText = (value) => value;

const labels = { full: "Entera", half: "Media pizza", half_and_half: "Mitad y mitad", slice: "Porcion" };
export default function PizzaSaleModeSelector({ option, value, onChange, canCombine = false, showPrices = true, disabled = false, tx = originalText }) {
  const modes = getPizzaSaleModes(option);
  return <section aria-label={tx("Modalidad de pizza")} style={{ display: "grid", gap: 10, margin: "16px 0" }}>
    <strong>{tx("Elegi la modalidad")}</strong>
    <p style={{ margin: 0 }}>{tx(modes.length === 1 && modes[0] === "full"
      ? "Esta presentacion se vende solo entera. Podes agregar todas las unidades que quieras."
      : "Elegi entre las modalidades habilitadas para este tamano.")}</p>
    {modes.map((mode) => <button type="button" key={mode} aria-pressed={value === mode}
      disabled={disabled || (mode === "half_and_half" && !canCombine)}
      onClick={() => onChange(mode)} style={{ padding: 16, borderRadius: 14, textAlign: "left", cursor: "pointer",
        display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap",
        border: value === mode ? "1px solid #2563eb" : "1px solid #cbd5e1", background: value === mode ? "#eff6ff" : "#fff", color: "#172033" }}>
      <strong>{tx(labels[mode])}</strong>
      {showPrices && <span>{mode === "half_and_half" ? tx(canCombine ? "Elegi la otra mitad" : "Sin otra mitad compatible")
        : getPizzaSaleModePrice(option, mode).toLocaleString("es-AR", { style: "currency", currency: "ARS" })}</span>}
    </button>)}
    {!modes.length && <p role="alert">{tx("No hay modalidades habilitadas para este tamano.")}</p>}
  </section>;
}
